import { POA } from '../types';
export default {
  type: POA,
  service: 'core.poa.network',
  url: 'https://core.poa.network',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
